import { render, staticRenderFns } from "./BaseIconButtonPeople.vue?vue&type=template&id=6c4845d2&scoped=true&"
import script from "./BaseIconButtonPeople.vue?vue&type=script&lang=js&"
export * from "./BaseIconButtonPeople.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c4845d2",
  null
  
)

export default component.exports